import PageContentWrapper from '@/components/templates/PageContentWrapper';
import { HiddenColumnsIndicator } from '@/components/ui/table/hidden-columns-indicator';
import { TABLE_LAYOUT_FILL_CLASSES } from '@/util/constants';

import { CampaignLogsToolbar } from '../../components/CampaignLogsToolbar';
import { CampaignLogsTable } from '../../components/Tables/CampaignLogsTable/Table';
import { useCampaignLogsPage } from '../../hooks/useCampaignLogsPage';

export const Logs = () => {
  const page = useCampaignLogsPage({ logsPathSegment: 'outreach/logs' });

  const hiddenColumnsIndicator = page.hasHiddenColumns ? (
    <HiddenColumnsIndicator
      onCustomize={() => page.setIsCustomizeColumnsOpen((prev) => !prev)}
      buttonRef={page.customizeButtonRef}
    />
  ) : undefined;

  return (
    <PageContentWrapper noGutters>
      <div className={TABLE_LAYOUT_FILL_CLASSES}>
        <CampaignLogsToolbar page={page} />

        <CampaignLogsTable
          data={page.currentPageData}
          fetchNextPage={page.goToNextPage}
          hasNextPage={page.hasNextPage}
          currentPageIndex={page.currentPageIndex}
          setCurrentPageIndex={page.setCurrentPageIndex}
          rowCount={page.totalRows}
          isLoading={page.listStatus === 'pending'}
          isFetchingNextPage={page.isFetchingNextPage}
          lastSeen={page.lastSeen}
          onReplay={page.triggerReplay}
          campaign_senders={page.campaign_senders}
          onRowClick={page.onRowClick}
          getRowClickable={page.getRowClickable}
          getRowHref={page.getRowHref}
          isAgentic={page.hasNbaConfig}
          hideReplay={page.hasNbaConfig}
          columnVisibility={page.columnVisibility}
          onColumnVisibilityChange={page.setColumnVisibility}
          sorting={page.sorting}
          onSortingChange={page.setSorting}
          paginationCenterContent={hiddenColumnsIndicator}
        />
      </div>
    </PageContentWrapper>
  );
};
